/**
 * Global configuration for the webchat widget
 */

interface Config {
  apiUrl: string;
}

// Function to get runtime configuration
function getRuntimeConfig() {
  // Check if runtime config is available (loaded from config.js)
  if (typeof window !== 'undefined' && (window as any).ORBITAR_CONFIG) {
    return (window as any).ORBITAR_CONFIG;
  }
  return null;
}

export const config: Config = {
  // Base URL for API calls
  // Priority: 1. Runtime config, 2. Build-time env var, 3. Localhost fallback
  apiUrl: getRuntimeConfig()?.apiUrl || import.meta.env.VITE_API_URL || 'http://localhost:3000',
}; 